import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import axios from "axios";
import { LeadProvider } from "@/context/LeadContext";
import { AdminAuthProvider, useAdminAuth } from "@/context/AdminAuthContext";
import { Noise } from "@/components/landing/Noise";
import { LeadModal } from "@/components/landing/LeadModal";
import { Toaster } from "@/components/ui/sonner";
import { initAnalytics } from "@/lib/analytics";
import { API } from "@/lib/api";
import LandingPage from "@/pages/LandingPage";
import LegalPage from "@/pages/LegalPage";
import DownloadPage from "@/pages/DownloadPage";
import NfcCardPage from "@/pages/NfcCardPage";
import PreviewPage from "@/pages/PreviewPage";
import FeaturesPage from "@/pages/FeaturesPage";
import PricingPage from "@/pages/PricingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import "@/App.css";

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function AnalyticsInit() {
  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((r) => initAnalytics(r.data.analytics || {}))
      .catch(() => {});
  }, []);
  return null;
}

function ProtectedRoute({ children }) {
  const { admin, checking } = useAdminAuth();
  if (checking) {
    return (
      <div className="min-h-screen bg-bone flex items-center justify-center text-ink/50">Loading…</div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <LeadProvider>
      <BrowserRouter>
        <AdminAuthProvider>
          <SmoothScroll />
          <AnalyticsInit />
          <Noise />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
            <Route path="/download" element={<DownloadPage />} />
            <Route path="/product/nfc-card" element={<NfcCardPage />} />
            <Route path="/preview/:slug" element={<PreviewPage />} />
            <Route path="/listing/:slug" element={<PreviewPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/concierge" element={<LandingPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dossier"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<LandingPage />} />
          </Routes>
          <LeadModal />
          <Toaster position="bottom-right" />
        </AdminAuthProvider>
      </BrowserRouter>
    </LeadProvider>
  );
}

export default App;
